
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getCreateGameDtoFormGroup() {
return new FormGroup({
    team1User1Id: new FormControl<number | undefined>(undefined, [Validators.required]),
    team1User2Id: new FormControl<number | undefined>(undefined),
    team2User1Id: new FormControl<number | undefined>(undefined, [Validators.required]),
    team2User2Id: new FormControl<number | undefined>(undefined),
})
;
}
      